export default __webpack_public_path__ + "static/media/rect-dot.7a1b48ed.svg";